import 'core-js';
import '@babel/polyfill';
import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { SuspenseDebounceLoader } from '@paysera/react-common';
import Vacancies from './Vacancies';

const elements = document.getElementsByClassName('vacancies');

if (elements.length) {
    [...elements].forEach((element) => {
        if (element) {
            render(
                <Suspense fallback={<SuspenseDebounceLoader />}>
                    <Vacancies />
                </Suspense>,
                element,
            );
        }
    });
}
